export default "__VITE_ASSET__B7hK4WEk__"